  <div
  [ngClass]="{
    'border': isDragging ,
    'border-success' : isDragging,
    'border-2' : isDragging,
    'rounded' : isDragging,
  }"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onFileDrop($event)"
  [attr.aria-disabled]="_disabled">

  <mat-form-field class="w-100" >
    <mat-label>{{_label}} File</mat-label>
    <mat-icon matPrefix>file_upload</mat-icon>
    <input
      matInput
      name="fileName"
      [id]="_id ?? ''"
      [readonly]="true"
      [value]="fileName"
      (click)="fileInput.click()"
      [required]="required"/>
  </mat-form-field>
  <input
    #fileInput
    type="file"
    [id]="_id ?? ''"
    (change)="valueChanged($event)"
    [accept]="_accept"
    [disabled]=_disabled
    hidden>
  </div>
